import { useRequiredContext } from "@redotech/react-util/context";
import { CartUIContext } from "../context/cart-ui-context";

export function useCartUI() {
  return useRequiredContext(CartUIContext);
}
